import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-ivory-deep px-4 sm:px-6 py-9 sm:py-12" data-id="element-37" data-mp="1hcrwc7ansus8">
      <div className="max-w-2xl mx-auto" data-id="element-38" data-mp="1hb8isoge0xu5">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-6" data-id="element-39" data-mp="1cfjde4hosmpx">
          Frequently asked questions
        </h2>

        <div className="flex flex-col gap-1.5" data-id="element-40" data-mp="252w0cfrrewjr">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="bg-white border border-petrol/10 rounded-lg overflow-hidden" data-id="element-41" data-mp="2065hjkoklmun" data-mpi={i}>
                <h3 data-id="element-42" data-mp="opyrpdu5fbcy">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full px-3.5 py-3 text-left flex justify-between items-center gap-3 hover:bg-ivory transition-colors duration-150 ease-out" data-id="element-43" data-mp="oqgvqwn1ytvf">
                    <span className="font-heading font-bold text-[12px] sm:text-sm leading-snug text-petrol" data-id="element-44" data-mp="1apsuuvn0tnac">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`w-4 h-4 text-green shrink-0 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-45" data-mp="1fqqc9607idas" />
                  </button>
                </h3>

                {isOpen && <div className="px-3.5 pb-3.5 text-[12px] sm:text-sm text-petrol/70 leading-relaxed" data-id="element-46" data-mp="s0dtf03faw5f">
                    {faq.a}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}